import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { transformCheckout, type TransformedCheckoutData } from "../transformers/CartResponseTransformer";
import type { CartResponseDTO } from "../dto/CartResponseDTO";

export async function getData(activeCartId: string): Promise<TransformedCheckoutData> {
  if (!activeCartId) {
    throw new Error("Cannot load checkout data without an explicit Active Cart identity");
  }
  const response = await occFetch(
    occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}/checkout/data`),
  );
  const dto: CartResponseDTO = await response.json();
  return transformCheckout(dto);
}
